"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var isInstantWin = function isInstantWin(challenge) {
  var _ref = challenge || {},
      challengeType = _ref.challengeType,
      _ref$registration = _ref.registration;

  _ref$registration = _ref$registration === void 0 ? {} : _ref$registration;
  var _ref$registration$can = _ref$registration.canBeRestarted,
      canBeRestarted = _ref$registration$can === void 0 ? undefined : _ref$registration$can,
      _ref$registration$use = _ref$registration.user,
      user = _ref$registration$use === void 0 ? undefined : _ref$registration$use,
      _ref$tags = _ref.tags,
      tags = _ref$tags === void 0 ? [] : _ref$tags;
  return challengeType === _constants.INSTANT_WIN || !!(canBeRestarted && user && tags.includes(_constants.INSTANT_WIN));
};

var _default = isInstantWin;
exports["default"] = _default;
//# sourceMappingURL=isInstantWin.js.map